<template>
    <div class="register-tab-container">
        <ProductsTable v-if="products.length>0" :categories="categories" :products="products"/>
    </div>
</template>

<script>
import Pagination from "@/components/cliente/base-components/Pagination";
import ProductsTable from "./ProductsTable.vue";

export default {
    name: 'BalanceTab',
    props: {
        svc: {
            type: Object
        },
        date: {
            type: Object
        },
        setLoading: {
            type: Function
        },
        categories:{
            type: Array
        }
    },
    components: {
        Pagination,
        ProductsTable
    },
    data() {
        return {
            products: [],
            page: 1
        }
    },
    mounted() {
        this.loadPage()
    },
    methods: {
        loadPage() {
            this.setLoading(true)
            this.svc.getCountDetails('totalLucro', this.date, this.page).then(resp => {
                this.products = resp.data
                this.setLoading(false)
            });
        },
        updatePage(page){
            this.page = page
            this.loadPage()
        }
    },
}
</script>

<style lang="scss" scoped>
.register-tab-container {
    height: 70vh;
    padding: 2vh 3vw;
}
</style>